import { useEffect, useState } from 'react';
import { batchesAPI } from '../services/api';
import useAsyncOperation from './useAsyncOperation';

const useBatchDetails = (batchId) => {
  const [batch, setBatch] = useState(null);
  const { loading, error, execute } = useAsyncOperation();

  useEffect(() => {
    if (!batchId) return;

    const fetchBatchDetails = async () => {
      const response = await execute(
        async () => batchesAPI.getById(batchId),
        { throwOnError: true }
      );

      if (response?.data) {
        setBatch(response.data);
      }
    };

    fetchBatchDetails();
  }, [batchId, execute]);

  return { batch, setBatch, loading, error };
};

export default useBatchDetails;

